import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DotCmsFacade } from '../../../../facades/dot-cms.facade';
import { Observable } from 'rxjs';
import { CustomDotCmsContentlet } from '../../../../models/contentlet/custom-dotcms-contentlet.model';
@Component({
  selector: 'custom-dot-cms-blog-author',
  templateUrl: './dot-cms-blog-author.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DotCmsBlogAuthorComponent {
  constructor(private dotCmsFacade: DotCmsFacade) {}
  @Input() isBlog: string;
  @Input() identifier: string;
  @Input() isCommentAuthor: string;
  contentlet$: Observable<CustomDotCmsContentlet>;
  host$: Observable<string>;

  ngOnChanges() {
    this.host$ = this.dotCmsFacade.getDotCmsHost$;
    this.contentlet$ = this.dotCmsFacade.getContentletByIdentifier$(this.identifier);
  }
  getAuthorContentByIdentifier$(identifier: string) {
    return this.dotCmsFacade.getContentletByIdentifier$(identifier);
  }
  buildImageSrcForAuthor(identifier: string, imageKey: string) {
    return this.dotCmsFacade.generateImageURIFromImageKey(identifier, imageKey);
  }
}
